export default {
  'supply-get-list': {
    method: 'post',
    url: '/supply/list'
  },
  supplyCreate: {
    method: 'post',
    url: '/supply'
  },
  supplyUpdate: {
    method: 'put',
    url: '/supply'
  },
  supplyDelete: {
    method: 'delete',
    url: '/supply'
  }
}
